module.exports = __webpack_public_path__ + "img/1495425072(1).e1c654de.png";